import React, {FC} from "react";
interface IProps {
  width: string;
  height: string;
}
const PencilIcon: FC<IProps> = ({height, width}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.3001 3.24922C14.5001 2.39922 13.6501 1.54922 12.8001 0.724219C12.6251 0.549219 12.4251 0.449219 12.2001 0.449219C11.9751 0.449219 11.7501 0.524219 11.6001 0.699219L2.17508 10.0492C2.02508 10.1992 1.92508 10.3742 1.85008 10.5492L0.475076 14.7492C0.400076 14.9492 0.450076 15.1492 0.550076 15.2992C0.675076 15.4492 0.850076 15.5492 1.07508 15.5492H1.17508L5.45008 14.1242C5.65008 14.0492 5.82508 13.9492 5.95008 13.7992L15.3251 4.44922C15.4751 4.29922 15.5751 4.07422 15.5751 3.84922C15.5751 3.62422 15.4751 3.42422 15.3001 3.24922ZM5.15008 13.0242C5.12508 13.0492 5.10008 13.0492 5.07508 13.0742L1.85008 14.1492L2.92508 10.9242C2.92508 10.8992 2.95008 10.8742 2.97508 10.8492L9.85008 3.99922L12.0251 6.17422L5.15008 13.0242ZM12.8001 5.37422L10.6251 3.19922L12.1501 1.67422C12.8751 2.37422 13.6001 3.12422 14.3001 3.84922L12.8001 5.37422Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PencilIcon;
